import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { Paragraph } from 'components/core/Typography';

export function VehicleGuide({ vehicleGuides }) {
	return (
		<div>
			<Paragraph
				size="standardMedium"
				weight="extraBold"
				color="black"
			>
				{vehicleGuides.title}
			</Paragraph>
			{vehicleGuides.guides.map((guide) => (
				<Fragment key={guide.subtitle}>
					<Paragraph
						size="small"
						weight="extraBold"
						color="black"
					>
						{guide.subtitle}
					</Paragraph>
					<Paragraph
						size="small"
						weight="standard"
						color="black"
					>
						{guide.paragraph}
					</Paragraph>
				</Fragment>
			))}
		</div>
	);
}

VehicleGuide.propTypes = {
	vehicleGuides: PropTypes.object,
};

export default VehicleGuide;
